const ProspectingCustomer = () => import('./ProspectingCustomer.vue')

const List = () => import('./pages/List.vue')
const Create = () => import('./pages/Create.vue')
const Edit = () => import('./pages/Edit.vue')

const routes = {
  component: ProspectingCustomer,
  path: '/cliente-prospeccao',
  meta: {
    label: 'Cliente Prospecção'
  },
  children: [
    {
      path: '',
      component: List,
      name: 'prospectingCustomersList',
      meta: {
        label: 'Gerenciar Clientes Prospecção',
        requiredPermission: {resource: 'prospectingCustomer', value: 'view'}
      }
    },
    {
      path: 'cadastro',
      component: Create,
      name: 'prospectingCustomerCreate',
      meta: {
        hidden: true,
        label: 'Cadastrar',
        requiredPermission: {resource: 'prospectingCustomer', value: 'manage'}
      }
    },
    {
      path: 'atualizar/:id',
      component: Edit,
      name: 'prospectingCustomerEdit',
      meta: {
        hidden: true,
        label: 'Atualizar',
        requiredPermission: {resource: 'prospectingCustomer', value: 'manage'}
      }
    }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/pages/prospecting-customer/routes.js